import Gradient48 from './Gradient48';

export default Gradient48;
